/**
 * `backBehavior` of the root `<Drawer>` (#651).
 *
 * The drawer router tells the web linker how each action moves browser history. A section switch
 * (`NAVIGATE` / `JUMP_TO` to another drawer route) PUSHES an entry only under `history` or
 * `fullHistory`; under the default `firstRoute` it replaces, so browser Back skipped the previous
 * screen. `fullHistory` rather than `history` so in-app Back (iOS, `router.back()`) also walks
 * A -> B -> A back through B to A instead of de-duplicating it. A `router.replace` stays a
 * replace under either: the router drops the replaced route from history and asks for no push.
 */
export const ROOT_DRAWER_BACK_BEHAVIOR = 'fullHistory';

/** First path segment — the root drawer screen a path lives under (`''` for `/`). */
const drawerSectionOf = (path: string): string => path.split(/[?#]/)[0].split('/').filter(Boolean)[0] ?? '';

/**
 * Whether going from `pathname` to `href` switches root drawer sections.
 *
 * Sidebar clicks across sections must NAVIGATE (a new browser entry) rather than replace,
 * because a cross-section `router.replace` is a true replace at the root drawer.
 */
export const crossesDrawerSection = (pathname: string, href: string): boolean =>
	drawerSectionOf(pathname) !== drawerSectionOf(href);
